import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  TextField,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Typography,
  Container,
  Box,
  Alert,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

const apiUrl = process.env.REACT_APP_API_URL;

const UserEdit = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { userId } = useParams();

  const [user, setUser] = useState({
    username: '',
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    role_id: '', // تم إضافة الدور
  });

  const [roles, setRoles] = useState([]); // تخزين قائمة الأدوار المتاحة
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  // ✅ جلب بيانات المستخدم عند تحميل الصفحة
  useEffect(() => {
    axios
      .get(`${apiUrl}/users/${userId}`)
      .then((response) => {
        setUser(response.data);
      })
      .catch((error) => {
        console.error('Failed to fetch user details:', error);
        setError(t('failed_to_fetch_user')); // `t` مستخدم هنا
      });

    axios
      .get(`${apiUrl}/roles`)
      .then((response) => {
        setRoles(response.data);
      })
      .catch((error) => {
        console.error('Failed to fetch roles:', error);
      });
  }, [userId, t]); // ✅ إضافة `t` إلى المصفوفة

  const handleChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .put(`${apiUrl}/users/${userId}`, user)
      .then(() => {
        setSuccess(t('user_updated_successfully'));
        setError('');
        setTimeout(() => {
          navigate('/user-list'); // إعادة توجيه بعد التحديث
        }, 2000);
      })
      .catch((error) => {
        console.error('Failed to update user:', error);
        setError(t('failed_to_update_user'));
      });
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          mt: 5,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Typography component="h1" variant="h5">
          {t('edit_user')}
        </Typography>
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 2 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="username"
            label={t('username')}
            name="username"
            value={user.username}
            onChange={handleChange}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            id="first_name"
            label={t('first_name')}
            name="first_name"
            value={user.first_name}
            onChange={handleChange}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            id="last_name"
            label={t('last_name')}
            name="last_name"
            value={user.last_name}
            onChange={handleChange}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label={t('email')}
            name="email"
            value={user.email}
            onChange={handleChange}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            id="phone"
            label={t('phone')}
            name="phone"
            value={user.phone}
            onChange={handleChange}
          />

          {/* ✅ اختيار الدور */}
          <FormControl fullWidth sx={{ mt: 2 }}>
            <InputLabel>{t('role')}</InputLabel>
            <Select
              id="role_id"
              name="role_id"
              value={user.role_id}
              onChange={handleChange}
            >
              {roles.map((role) => (
                <MenuItem key={role.role_id} value={role.role_id}>
                  {role.role_name} | {role.role_name_ar}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* رسائل النجاح والخطأ */}
          {error && (
            <Alert severity="error" sx={{ mt: 2 }}>
              {error}
            </Alert>
          )}
          {success && (
            <Alert severity="success" sx={{ mt: 2 }}>
              {success}
            </Alert>
          )}

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              mt: 3,
              mb: 2,
            }}
          >
            <Button type="submit" variant="contained" sx={{ width: '48%' }}>
              {t('update')}
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => navigate('/user-list')}
              sx={{ width: '48%' }}
            >
              {t('cancel')}
            </Button>
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default UserEdit;
